export default function toQueryFormat(string) {
  return string.replace('-', '');
}
